module.exports = __webpack_public_path__ + "assets/img/wuzhaung-3e9360cb.png";